export const FETCH_LOAD_PROJECT_SETTINGS_REQUEST = 'FETCH_LOAD_PROJECT_SETTINGS_REQUEST'
export const FETCH_LOAD_PROJECT_SETTINGS_SUCCESS = 'FETCH_LOAD_PROJECT_SETTINGS_SUCCESS'
export const FETCH_LOAD_PROJECT_SETTINGS_FALUIRE = 'FETCH_LOAD_PROJECT_SETTINGS_FALUIRE'

